import React from "react";
import { Text, View } from "@react-pdf/renderer";
import PrintApplicationStyles from "../PrintApplicationStyles";

const PrintSection9 = ({ section9 }) => {
  return (
    <>
      <Text break style={PrintApplicationStyles.sectionheader}>
        Section 9 – Additional Information
      </Text>

      <Text style={PrintApplicationStyles.subcontent}>
        9.01 General Additional Information
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Please provide any additional information relevant to your application
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section9?.additionalInformation || ""}</Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        9.02 Branding and Marketing Support
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              1. Do you require branding or marketing support?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.brandingAndMarketingSupportOptions &&
                section9.brandingAndMarketingSupportOptions.length > 0
                  ? section9.brandingAndMarketingSupportOptions.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              2. Which of the following branding or marketing services do you require? (Select all that apply)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.brandingAndMarketingServices &&
                section9.brandingAndMarketingServices.length > 0
                  ? section9.brandingAndMarketingServices.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        9.03 Recruitment Checklist
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Checks & Documents Enclosed
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.checkAndDocumentEnclosed &&
                section9.checkAndDocumentEnclosed.length > 0
                  ? section9.checkAndDocumentEnclosed.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Have you read and understood the job description and person
              specification for the role?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.readJobDescription === true
                  ? "Yes"
                  : section9?.readJobDescription === false
                    ? "No"
                    : section9?.readJobDescription === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Have you provided all relevant information and documentation
              requested in this application?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.providedAllInformation === true
                  ? "Yes"
                  : section9?.providedAllInformation === false
                    ? "No"
                    : section9?.providedAllInformation === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Are you willing to undergo a Criminal Records Bureau (CRB) check
              and/or Disclosure Barring Service (DBS) check if required?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.willingForCRBCheck === true
                  ? "Yes"
                  : section9?.willingForCRBCheck === false
                    ? "No"
                    : section9?.willingForCRBCheck === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Are you willing to undergo an occupational health assessment if
              required?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.willingForHealthAssessment === true
                  ? "Yes"
                  : section9?.willingForHealthAssessment === false
                    ? "No"
                    : section9?.willingForHealthAssessment === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        9.04 Additional Disclosure & Paperwork Required
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Financial Issues - Bankruptcy
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.financialIssue && section9.financialIssue.length > 0
                  ? section9.financialIssue.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              CCJs – Must be settled or in a repayment plan
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.CCJs && section9.CCJs.length > 0
                  ? section9.CCJs.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Debt Management Plan / Arrangements
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.debtManagementPlan &&
                section9.debtManagementPlan.length > 0
                  ? section9.debtManagementPlan.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Defaults / Mortgage Arrears
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.defaults && section9.defaults.length > 0
                  ? section9.defaults.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              IVA/Trust Deed
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.IVTrustDeed && section9.IVTrustDeed.length > 0
                  ? section9.IVTrustDeed.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        9.05 Complaints and Regulatory History
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Complaints
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.complaints && section9.complaints.length > 0
                  ? section9.complaints.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Warnings / Breaches / Investigations
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.warnings && section9.warnings.length > 0
                  ? section9.warnings.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Suspension / Termination
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.suspension && section9.suspension.length > 0
                  ? section9.suspension.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Are there any complaints or disciplinary issues from your previous
              employment that are relevant to this role?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.complaintsOrDisciplinary === true
                  ? "Yes"
                  : section9?.complaintsOrDisciplinary === false
                    ? "No"
                    : section9?.complaintsOrDisciplinary === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section9?.complaintsOrDisciplinary && (
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Details</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section9?.complaintsOrDisciplinaryDetails || ""}</Text>
              </View>
            </View>
          )}
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        9.06 Additional Regulatory and Company Information
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Convictions (excluding motoring unless resulted in a ban)
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.convictions && section9.convictions.length > 0
                  ? section9.convictions.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Directorships
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.directorships && section9.directorships.length > 0
                  ? section9.directorships.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Liquidations / Company in Administration
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.liquidations && section9.liquidations.length > 0
                  ? section9.liquidations.join(", ")
                  : ""}
              </Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        9.07 Financial Issues - Additional Details
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Have you ever had any County Court Judgements (CCJs) against you?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.hasCountyCourtJudgements === true
                  ? "Yes"
                  : section9?.hasCountyCourtJudgements === false
                    ? "No"
                    : section9?.hasCountyCourtJudgements === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Have you ever been registered on the Individual Insolvency
              Register?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.insolvencyRegister === true
                  ? "Yes"
                  : section9?.insolvencyRegister === false
                    ? "No"
                    : section9?.insolvencyRegister === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Are there any other financial matters we should be aware of?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.otherFinancialMatters === true
                  ? "Yes"
                  : section9?.otherFinancialMatters === false
                    ? "No"
                    : section9?.otherFinancialMatters === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
          {section9?.otherFinancialMatters && (
            <View style={PrintApplicationStyles.inputRow}>
              <Text style={PrintApplicationStyles.inputLabel}>Details</Text>
              <View style={PrintApplicationStyles.inputBox}>
                <Text>{section9?.otherFinancialMattersDetails || ""}</Text>
              </View>
            </View>
          )}
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        9.08 Branding and Marketing Preferences
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              May we use your name and/or image in our marketing materials,
              website, and promotional activities?
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>
                {section9?.allowMarketingUse === true
                  ? "Yes"
                  : section9?.allowMarketingUse === false
                    ? "No"
                    : section9?.allowMarketingUse === "N/A"
                      ? "Not Applicable"
                      : ""}
              </Text>
            </View>
          </View>
        </View>
      </View>

      <Text  style={PrintApplicationStyles.subcontent}>
        9.09 Additional Comments
      </Text>
      <View style={PrintApplicationStyles.tableRow}>
        <View style={PrintApplicationStyles.inputSection}>
          <View style={PrintApplicationStyles.inputRow}>
            <Text style={PrintApplicationStyles.inputLabel}>
              Please provide any additional information or comments you feel are
              relevant to your application:
            </Text>
            <View style={PrintApplicationStyles.inputBox}>
              <Text>{section9?.additionalComments || ""}</Text>
            </View>
          </View>
        </View>
      </View>
    </>
  );
};

export default PrintSection9;
